const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('ramon-avocado', 'forum/states/HomeState');